import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Add: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path fill='none' d='M0 0h24v24H0z' />
      <path
        fill='currentColor'
        d='M21 11.25h-8.25V3h-1.5v8.25H3v1.5h8.25V21h1.5v-8.25H21v-1.5z'
      />
    </svg>
  </i>
);

Add.displayName = 'Add';
export default Add;
export { styles };
